type ProName = {
  first_name?: string | null;
  last_name?: string | null;
  display_name?: string | null;
};

const getFullName = (pro: ProName): string =>
  [pro.first_name, pro.last_name].filter(Boolean).join(" ") || pro.display_name || "";

export { getFullName };
